/**
 * Single source of truth for the public blog archive page size.
 *
 * Plain ESM so both the application (TypeScript) and the Node prerender
 * script (`scripts/prerender-marketing.mjs`) import the same constant
 * without a TS loader.
 */
export const BLOG_PAGE_SIZE = 10;